// @flow
import React, { Component } from 'react';
import { HeaderNavItemLink } from './DesktopHeaderStyles';
import { DefaultIcon } from '../../../components/Icon';

type Props = {
  label: string,
  to: string,
  icon: string,
  isActive?: () => boolean
};

export default class HeaderNavItem extends Component<Props> {
  render() {
    return (
      <HeaderNavItemLink to={this.props.to} isActive={this.props.isActive}>
        <DefaultIcon name={this.props.icon} />
        {this.props.label}
      </HeaderNavItemLink>
    );
  }
}
